import { Image, type ImageProps } from "@tokenterminal/ui/Image"
import { getTooltipProps } from "modules/tooltip/getTooltipProps"
import { projectLogo } from "./ProjectLogo.css"

interface Props extends Partial<ImageProps> {
  name: string
  logo: string
  size?: number | `${number}`
}

export const ProjectLogo = ({
  name,
  logo,
  size = "40",
  className,
  style,
  ...rest
}: Props) => {
  return (
    <Image
      flexShrink="0"
      borderRadius="rounded"
      src={`https://static1.tokenterminal.com/${logo}`}
      width={size}
      height={size}
      alt={`${name} - Logo`}
      className={[projectLogo, className]}
      style={{
        width: `${size}px`, // Pass size as width to Image container becasue otherwise eg. flex containers cant calculate this element's size correctly. We use flexShrink=0 here anyway so this should be fine
        ...style,
      }}
      {...getTooltipProps(name)}
      {...rest}
    />
  )
}
